
define('jsx!components/finn-blink/main',['jquery', 'underscore', 'react', 'lib', 'event-manager', 'finn-carousel'], function($, _, React, lib, eventManager, FINNExternalDistribution) {
    'use strict';

    var PureRenderMixin = React.addons.PureRenderMixin;

    var FinnBlink = React.createClass({displayName: "FinnBlink",
        getDefaultProps: function() {
            return {
                id: '',
                placeholder: null,
            };
        },

        getInitialState: function() {
            return {
                collapsed: false,
            };
        },

        componentDidMount: function() {
            this.createBlink();
        },

        createBlink: function() {
            var options = {
                remote: '//www.finn.no/distribution-front/external/carousel',
            };

            var blinkAd = new FINNExternalDistribution.Fixed(options);
            var blinkOptions = {
                selector: '#' + this.props.id,
                position: this.props.id + (lib.isMobile() ? 'Mobile' : 'Desktop'),
                channel: 'e24',
                rec: false,
                limit: 15,
                distributionTypes: ['REALESTATE', 'JOB'],
            };

            blinkAd.inject(blinkOptions, _.bind(function(err, result) {
                if (err) {
                    this.setState({
                        collapsed: true,
                    });
                    eventManager.emit('collapse-blink', this.props.placeholder);
                }
            }, this));
        },

        render: function() {
            var collapsed = this.state.collapsed ? 'collapsed' : '';

            return (
                React.createElement("div", {id: this.props.id, className: collapsed})
            );
        }
    });

    return function renderComponent(element, config) {
        if (!element) {
            return;
        }
        config = config || {};

        config.placeholder = element.getAttribute('data-placeholder');
        config.id = (config.placeholder === 'finn_blink_front') ?
                'blinkAdFront' : 'blinkAdArticle'

        React.render(React.createElement(FinnBlink, React.__spread({},  config)), element);
    };
});

